/* PIEDREROS — movimiento al hacer scroll (MAQUINA v8, 2026-10-18).
   Marca html.cp-motion y agrega .is-in a lo que entra a pantalla: pila de gorras, franjas Maxdale, golpes.
   Respaldo: revisa la posicion al cargar y al hacer scroll por si el IntersectionObserver no dispara. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('cp-motion');
  const golpes = '.cp-heroes__title, .cpc__golpe, .cpb__golpe, .cpfc__golpe, .cpp__golpe, .shopify-section--media-grid .section-header :is(h2,.h2), .shopify-section--featured-collections :is(h2,.h2), .shopify-section--image-with-text :is(h2,.h2)';
  const pending = new Set();
  const show = (el) => { el.classList.add('is-in'); pending.delete(el); io.unobserve(el); };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) show(e.target); });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  const check = () => {
    pending.forEach((el) => { const r = el.getBoundingClientRect(); if (r.height && r.top < innerHeight * 0.9 && r.bottom > 0) show(el); });
  };
  const add = (el) => { if (!pending.has(el) && !el.classList.contains('is-in')) { pending.add(el); io.observe(el); } };
  const watch = (root = document) => {
    root.querySelectorAll(golpes).forEach((el) => { el.classList.add('cp-sube'); add(el); });
    root.querySelectorAll('.cpp__capas, .cpc').forEach(add);
    requestAnimationFrame(check); setTimeout(check, 700);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch()); else watch();
  window.addEventListener('load', check);
  window.addEventListener('scroll', check, { passive: true });
  document.addEventListener('shopify:section:load', (e) => watch(e.target));
})();

/* v10: en la ficha, oculta opciones con un solo valor (color o estilo unico); la talla siempre se ve. */
(() => {
  const hide = () => document.querySelectorAll('.variant-picker__option').forEach((o) => {
    const legend = (o.querySelector('legend') || {}).textContent || '';
    if (o.querySelectorAll('input[type=radio]').length === 1 && !/size|talla/i.test(legend)) o.classList.add('cp-uno');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide); else hide();
  document.addEventListener('shopify:section:load', hide);
})();
